export default __webpack_public_path__ + "static/media/me-icon-active.b034a9b0.webp";